import { action } from 'mobx';
import moment from 'moment';
import Entity, { ISerializable } from '../../Entity';
import ScenarioNode from '../node/scenario-node';
import BaseFilter from '../../BaseFilter';
import ContactScenario from '../../contact/scenario';

export class ScenarioNodeListener extends Entity implements ISerializable {
    constructor(listener?: Partial<ScenarioNodeListener>) {
        super();
        if (listener) this.update(listener);
    }

    createdDate: moment.Moment;
    expirationDate?: moment.Moment;
    node: ScenarioNode;
    studentScenario: ContactScenario;
    nodePayloadJson: string;

    toJson() {
        return {
            id: this.id,
            expirationDate: this.expirationDate,
            nodeId: this.node?.id,
            studentScenarioId: this.studentScenario?.id,
            nodePayloadJson: this.nodePayloadJson
        }
    }

    clone(changes?: Partial<ScenarioNodeListener>) {
        return new ScenarioNodeListener({
            ...this,
            node: this.node?.clone(),
            studentScenario: this.studentScenario?.clone(),
            ...changes
        });
    }

    @action update(partnership: Partial<ScenarioNodeListener>, allowUndefined = false) {
        super.update(partnership, allowUndefined);
    }

    static fromJson(json: any): ScenarioNodeListener {
        return new ScenarioNodeListener({
            ...json,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            expirationDate: json.expirationDate ? moment(json.expirationDate) : undefined,
            node: json.node ? ScenarioNode.fromJson(json.node) : null,
            studentScenario: json.studentScenario ? ContactScenario.fromJson(json.studentScenario) : null,
        });
    }
}

export class ScenarioNodeListenerFilter extends BaseFilter<ScenarioNodeListener> {
    constructor(filter?: Partial<ScenarioNodeListenerFilter>) {
        super();
        if (filter) this.update(filter);
    }

    nodeId?: string;

    update(changes: Partial<ScenarioNodeListenerFilter>) {
        super.update(changes);
    }
}
